import React, { useState } from 'react';
export const PortfolioSection = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const categories = [{
    id: 'all',
    name: 'All'
  }, {
    id: 'tech',
    name: 'Technology'
  }, {
    id: 'finance',
    name: 'Finance'
  }, {
    id: 'healthcare',
    name: 'Healthcare'
  }, {
    id: 'real-estate',
    name: 'Real Estate'
  }];
  const portfolioItems = [{
    name: 'NexGen Technologies',
    category: 'tech',
    description: 'AI-powered enterprise software solutions',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    name: 'FinCore Systems',
    category: 'finance',
    description: 'Digital banking infrastructure provider',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    name: 'MediScan',
    category: 'healthcare',
    description: 'Advanced medical imaging solutions',
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    name: 'Urban Spaces',
    category: 'real-estate',
    description: 'Smart commercial property development',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    name: 'DataSphere',
    category: 'tech',
    description: 'Cloud data management platform',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2068&q=80'
  }, {
    name: 'HealthConnect',
    category: 'healthcare',
    description: 'Telehealth service provider',
    image: 'https://images.unsplash.com/photo-1504439468489-c8920d796a29?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80'
  }];
  const filteredItems = activeFilter === 'all' ? portfolioItems : portfolioItems.filter(item => item.category === activeFilter);
  return <section id="portfolio" className="py-20 bg-gray-50" data-id="element-196">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2351]" data-id="element-199">
            Portfolio Highlights
          </h2>
          <div className="w-20 h-1 bg-[#38b2ac] mx-auto mb-8" data-id="element-200"></div>
          <p className="text-xl text-gray-600" data-id="element-201">
            A selection of our strategic investments across industries
          </p>
        </div>
        <div className="flex flex-wrap justify-center mb-12 gap-2" data-id="element-202">
          {categories.map(category => <button key={category.id} onClick={() => setActiveFilter(category.id)} className={`px-5 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${activeFilter === category.id ? 'bg-[#0a2351] text-white' : 'bg-white text-gray-600 hover:bg-gray-100'}`} data-id="element-203">
              {category.name}
            </button>)}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-204">
          {filteredItems.map((item, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-205">
              <div className="h-48 overflow-hidden" data-id="element-206">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500" data-id="element-207" />
              </div>
              <div className="p-6" data-id="element-208">
                <h3 className="text-xl font-semibold mb-2 text-[#0a2351]" data-id="element-209">
                  {item.name}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-210">{item.description}</p>
                <span className="inline-block px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-xs font-medium" data-id="element-211">
                  {categories.find(cat => cat.id === item.category)?.name}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};